<template>
  <Section :content="supplyChainCollab" />
</template>

<script>
// @ is an alias to /src
require('@/assets/css/styles.css');
import Section from '@/components/section.vue';
export default {
  name: 'SectionSupplyChainCollab',
  components: {
    Section,
  },
  data() {
    return {
      supplyChainCollab: { 
        eyebrow: 'TrinApp\u2122 Projects',
        eyebrowIcon: 'trinapp_projects.png',
        headline: 'Full Supply Chain Collaboration',
        paragraphs: [
          'TrinPod\u2122 provides detailed access control for any level of data.',
          'Give access to a whole TrinPod\u2122, one container, one file, or a large data set, or even one data point.',
          'Assign access to all people working for a business, sub-organization, group, or individual.'
        ],
        id: 'supply-chain-collab',
        image: 'Construction-Supply-Chain-Collaboration-web.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-light-grad',
        /*html: 
          '<div>' + 
          ' <h5 class="mb-4">TrinPod\u2122 provides detailed access control for any level of data.' + 
          ' <h5 class="mb-4">Give access to a whole TrinPod\u2122, one container, one file, or a large data set, or even one data point.' +
          ' <h5 class="mb-4">Assign access to all people working for a business, sub-organization, group, or individual.</h5>' + 
          '</div>',*/
        learnMoreLink: ''
      }
    }
  }
};
</script>
